<h2 mat-dialog-title>Aggiungi Nota</h2>
<mat-dialog-content  class="mat-typography">
  <div class="form-container">
    <form [formGroup]="registerForm">
      <h2>Inserisci la nota</h2>
      

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Codice !== 'none' ? 'block' : 'none'">
        <mat-label>Codice commessa</mat-label>
        <input matInput formControlName="Codice" name="Codice">
      </mat-form-field>

            <mat-form-field [style.display]="getConfigurazione().Noteamministrazione" style="height:120px" class="example-full-width">

                        <textarea matInput
                            cdkTextareaAutosize placeholder="..." formControlName="Noteamministrazione" name="Noteamministrazione"
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"></textarea>
              </mat-form-field>

    </form>

  </div >


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onAnnulla()">Annulla</button>
  <button mat-button color="primary" (click)="onSalva()" [disabled]="registerForm.invalid">Salva</button>
</mat-dialog-actions>